<template>
  <v-radio-group
    @change="$emit('onChange', $event)"
    :value="selected"
    hide-details
    row>
    <v-radio
      v-for="(grade, index) in grades"
      :key="index"
      :label="grade.name"
      :value="grade.id"
      :disabled="!isValidGrade(grade.id) && disabled"
      color="secondary"
    ></v-radio>
  </v-radio-group>
</template>

<script>
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Number,
      required: true,
    },
    modeShingaku: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    ...mapGetters([
      'isValidGrade',
    ]),
    grades() {
      const grades = cloneDeep(this.$store.state.master.allGrades)
      if (this.modeShingaku && !grades.find(grade => grade.id === 10)) {
        grades.push({ id: 10, name: '進学教材(新研究/スタプロ)' })
      }
      return grades
    },
  },
}
</script>
